export const API_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL
  : 'https://api-dev.greenchoice.io/api'
export const geoCodeAPIKEy = 'AIzaSyB8js5QCuoIkh_rxsTM8EPwjqXET8m8xwU'
export const DOWNLOAD_URL = 'https://s3.amazonaws.com/gcapp'



// WEBPACK FOOTER //
// ./src/constants.js